import React from 'react';
import { css } from '@emotion/css';
import Container from 'evcharging/components/Container';
import { Theme } from 'evcharging/app/themes';
import useTheme from 'evcharging/hooks/useTheme';
import Paragraph from 'evcharging/components/Paragraph';
import Spacer from 'evcharging/components/Spacer';
import header from 'evcharging/assets/ev-rebates/header.png';
import useI18n from 'evcharging/hooks/useI18n';

const RebatesHeader = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  return (
    <header className={styles.root}>
      <Container>
        <div className={styles.content}>
          <h1 className={styles.title}>{t('rebates.header')}</h1>
          <Spacer value={20} />
          <Paragraph color={'light'} maxWidth={780} margin={'0 auto'} textAlign={'center'}>
            {t('rebates.intro')}
          </Paragraph>
        </div>
      </Container>
    </header>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%),
      url(${header});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    color: #fff;
  `,
  content: css`
    margin: auto 0;
    padding: 225px 0 200px;
    ${theme.breakpoints.mobile.down} {
      padding: 100px 0;
    }
  `,
  title: css`
    font-weight: 500;
    font-size: 48px;
    line-height: 60px;
    text-align: center;
    ${theme.breakpoints.mobile.down} {
      font-size: 32px;
      line-height: 40px;
    }
  `,
});

export default RebatesHeader;
